export interface IDosageType {
    dosageTypeId: string,
    nameEnglish: string,
    nameArabic: string,
    dosageTypeSubTypes: IDosageTypeSubType[]
}

interface IDosageTypeSubType {
    dosageTypeSubTypeId?: string,
    dosageSubTypeId: string,
    dosageSubtypeNameEnglish?: string,
    dosageSubtypeNameArabic?: string
}

export const dosageTypeconfig = {
    entityName: 'CONFIGURATION.DOSAGE_TYPE.TITLE',
    nameEnglish: 'FORM_FIELD.ENGLISH_NAME',
    nameArabic: 'FORM_FIELD.ARABIC_NAME',
    dosageSubType: 'CONFIGURATION.DOSAGE_TYPE.SUB_TYPE'
};